import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Field } from 'redux-form';
import renderArticleTags from './components/renderArticleTags';
import {withTranslation} from "react-i18next";

class TagsCard extends Component {


  render() {
    const { parent_category, t } = this.props;
    return (
      <Card>
        <CardBody>
          <div className="card__title">
            <h5 className="bold-text">{t('write.blockchain_tags.title')}</h5>
            <h5 className="subhead">{t('write.blockchain_tags.subtitle')}</h5>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('write.blockchain_tags.select_tags')}:</span>
            <div className="form__form-group-field">
              <Field
                name="tags"
                format={null}
                lockedTags={ [parent_category] }
                addTagText={t('write.blockchain_tags.add_tag')}
                component={renderArticleTags}
              />
            </div>
            <div className="card__title">
              <h5 className="subhead">{t('write.blockchain_tags.description')}</h5>
            </div>
          </div>
        </CardBody>
      </Card>
    )

  }

}

export default withTranslation('dashboard')(TagsCard);
